import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
import { buildPageMeta } from 'containers/App/screens/Tube/utils';
import fetchData from 'utils/api';

const { NEWTUBE_API_SERVER } = url;

const FETCH_USER_TREEVIEWS_REQUEST =
  'tube/companyrules/user/FETCH_USER_TREEVIEWS_REQUEST';
const FETCH_USER_TREEVIEWS_SUCCESS =
  'tube/companyrules/user/FETCH_USER_TREEVIEWS_SUCCESS';
const FETCH_USER_TREEVIEWS_FAILURE =
  'tube/companyrules/user/FETCH_USER_TREEVIEWS_FAILURE';
const FETCH_USER_VIEW_REQUEST =
  'tube/companyrules/user/FETCH_USER_VIEW_REQUEST';
const FETCH_USER_VIEW_SUCCESS =
  'tube/companyrules/user/FETCH_USER_VIEW_SUCCESS';
const FETCH_USER_VIEW_FAILURE =
  'tube/companyrules/user/FETCH_USER_VIEW_FAILURE';

export default function reducer(
  state = {
    rulesList: [],
    rules: {},
    rulesListMeta: {},
    error: {},
    isLoading: false,
  },
  action
) {
  switch (action.type) {
    case FETCH_USER_TREEVIEWS_FAILURE: {
      return Object.assign({}, state, {
        error: action.error,
        isLoading: false,
      });
    }
    case FETCH_USER_TREEVIEWS_REQUEST: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case FETCH_USER_TREEVIEWS_SUCCESS: {
      const list = action.response.data;
      const meta = buildPageMeta(action.response.meta);
      return Object.assign({}, state, {
        isLoading: false,
        rulesList: list,
        rulesListMeta: meta,
      });
    }
    case FETCH_USER_VIEW_SUCCESS: {
      const data = action.response.data;
      return Object.assign({}, state, {
        rules: data,
      });
    }
    default:
      return state;
  }
}
/* 列表樹狀資料查詢(使用者畫面) */
export function fetchUserTreeViews(keyword, functionCode) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/TreeView`,
      method: 'GET',
      types: [
        FETCH_USER_TREEVIEWS_REQUEST,
        FETCH_USER_TREEVIEWS_SUCCESS,
        FETCH_USER_TREEVIEWS_FAILURE,
      ],
      headers: {
        functionCode,
        actionCode: 'Default',
      },
      params: keyword,
    },
  };
}

/* 分類單筆查詢(使用者畫面) */
export function fetchUserView(companyRegulationsId, functionCode) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/${companyRegulationsId}`,
      method: 'GET',
      headers: {
        functionCode,
        actionCode: 'Default',
      },
      types: [
        FETCH_USER_VIEW_REQUEST,
        FETCH_USER_VIEW_SUCCESS,
        FETCH_USER_VIEW_FAILURE,
      ],
    },
  };
}
/* 下載附件 */
export function downloadEnrollAttachment(apiUrl) {
  const fetchOptions = {
    mode: 'cors',
    method: 'GET',
    headers: {},
  };
  let downloadUrl = apiUrl.split('api/')[1];
  fetchOptions.headers['Content-Type'] = 'application/json';
  downloadUrl = `${NEWTUBE_API_SERVER}${downloadUrl}`;
  return fetchData(downloadUrl, fetchOptions);
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/CompanyRules/screens/CompanyRegulation/reducers/index.js
 **/